import cx from 'classnames';
import { NEW_STATE } from '../../../constants';
import { ServiceInsightDetailsProps } from '../../types';
import { EquipmentDetails } from '../equipment-info';
import { ServiceInsightImpactTitle } from '../service-insight-impact-title';
import { ServiceInsightViewDetails } from '../service-insight-view-details';
import styles from '../service-insight-card.module.scss';

export const ServiceInsightContentDetails = ({
  serviceInsights,
  isDesktop
}: ServiceInsightDetailsProps) => {
  const isNewInsight = serviceInsights.userRelatedState === NEW_STATE;

  return (
    <div
      className={cx('row align-items-center', {
        'm-md-0 m-sm-0 gx-0 gy-0': !isDesktop
      })}
    >
      <div
        className={cx(
          {
            'col-lg-4 order-1': isDesktop
          },
          {
            [`${styles['service-insight-seperator']} pt-2 col-12 order-2`]:
              !isDesktop
          },
          {
            [styles['equipment']]: isDesktop && !isNewInsight
          }
        )}
      >
        <EquipmentDetails
          equipmentDetails={serviceInsights.equipmentInfo}
          isNewInsight={isNewInsight}
          isDesktop={isDesktop}
        />
      </div>
      <div
        className={cx(
          { 'col order-2': isDesktop },
          { 'col-12 order-1 mb-1 pb-2': !isDesktop }
        )}
      >
        <ServiceInsightImpactTitle
          title={serviceInsights.payload.title}
          impact={serviceInsights.payload.impact}
        />
      </div>
      <div className="align-content-blg-center col-auto p-0 pe-3 order-3">
        <ServiceInsightViewDetails
          serviceInsights={serviceInsights}
          isDesktop={isDesktop}
        />
      </div>
    </div>
  );
};
